// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import createSvgIcon from '../utils/createSvgIcon';
import React from "react";


export default createSvgIcon(
  <><path d="M5.252 8.078 C 5.035 8.211,4.941 8.488,5.044 8.693 C 5.068 8.741,6.756 10.449,8.794 12.490 L 12.500 16.200 16.192 12.510 C 18.223 10.480,19.911 8.771,19.943 8.712 C 20.149 8.324,19.696 7.848,19.307 8.044 C 19.259 8.068,17.708 9.598,15.860 11.444 L 12.500 14.800 9.160 11.457 C 7.323 9.619,5.771 8.089,5.712 8.057 C 5.563 7.978,5.404 7.986,5.252 8.078 " stroke="none" fillRule="evenodd" fill="black"></path></>, 
'ArrowheadDownIcon', {
  viewBox: '0 0 24 24',
  height: '24',
  width: '24',
});